/**
 * Use this to add a new style tag to the header
 */
function createStyle(document: Document, css: string, id?: string) {
    // https://stackoverflow.com/a/46079845
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    if (id) {
        style.id = id;
    }

    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
}

export default createStyle;
